<template>
  <v-app>
    <Header></Header>
    <Navbar v-if="!$route.meta.hideNavigation" />
    <v-main>
      <transition :name="transitionName" mode="out-in">
        <router-view></router-view>
      </transition>
      <notifications group="messages" position="top right" animation-type="velocity" />
    </v-main>
  </v-app>
</template>

<script>
import Navbar from './components/Navbar'
import Header from './components/Header'
import { mapGetters } from 'vuex'
export default {
  name: 'App',
  components: {
    Navbar,
    Header
  },
  data () {
    return {
      transitionName: 'fade'
    }
  },
  computed: {
    ...mapGetters({ theme: 'colorPaletteServices/theme' })
  },
  mounted () {
    this.$store.commit('colorPaletteServices/changeTheme', 'Light Mode')
  },
  methods: {
    initColorPalette () {
      this.$vuetify.theme.themes.light.primary = this.theme.primaryColor
      this.$vuetify.theme.themes.light.secondary = this.theme.secondaryColor
      for (const color in this.theme) {
        document.documentElement.style.setProperty(`--${color}`, this.theme[color])
      }
    }
  },
  watch: {
    '$route.path': {
      handler: function (path) {
        if ((path === '/session/signup') || (path === '/session/login') || (path === '/session/reset-password')) {
          this.showVersion = false
        } else this.showVersion = true
      }
    },
    theme () {
      this.initColorPalette()
    },
    '$route' (to, from) {
      if ((to.path === '/session/login') || (to.path === '/session/signup') || (to.path === '/session/reset-password')) {
        console.log(to.path)
        this.transitionName = ''
      } else {
        this.transitionName = 'fade'
      }
    }
  }
}
</script>
<style>
  @import "https://fonts.googleapis.com/css?family=Material+Icons|Material+Icons+Outlined|Material+Icons+Two+Tone|Material+Icons+Round|Material+Icons+Sharp";
  .fade-enter-active,
  .fade-leave-active {
    transition: 0.3s all ease;
  }

  .v-main {
     padding-top: 57px !important;
  }

  .fade-enter,
  .fade-leave-active {
    opacity: 0
  }
  *{
    scrollbar-color: #c1c1c1 white;
  }
</style>
